import Configs from '../../../../config.js';
import { TableColumn, TableColumns } from '../../../../components/_tables/TableColumns';
import moment from 'moment';


function presentData(items) {

    return items.map(item => {
        item.date = moment(item.date).format(Configs.formats.date);

        return item;
    });
}

// Table Pagination Columns Scheme
function tableColumnDefinitions() {

    const idCol = new TableColumn()
        .setKey('id')
        .setDisplayName('#')

    const valueCol = new TableColumn()
        .setKey('value')
        .setDisplayName('Value')
        .setEditKey('value')

    const descriptionCol = new TableColumn()
        .setKey('description')
        .setDisplayName('Description')
        .setEditKey('description')

    const dateCol = new TableColumn()
        .setKey('date')
        .setType('date')
        .setDisplayName('Date')
        .setEditKey('date')

    const tableCols = new TableColumns([
        valueCol,
        descriptionCol,
        dateCol
    ])

    return tableCols;

}

/**
 * Exports
 */
export {
    presentData,
    tableColumnDefinitions
}